import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Chip,
  Box,
} from '@mui/material';
import {
  Assignment as WorkIcon,
  CheckCircle as CompleteIcon,
  Pending as PendingIcon,
  Build as BuildIcon,
} from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';

const getActivityIcon = (type, status) => {
  if (type === 'work_order') {
    if (status === 'completed') return <CompleteIcon />;
    if (status === 'in-progress') return <BuildIcon />;
    return <PendingIcon />;
  }
  return <WorkIcon />;
};

const getActivityColor = (type, status) => {
  if (type === 'work_order') {
    if (status === 'completed') return 'success.main';
    if (status === 'in-progress') return 'info.main';
    return 'warning.main';
  }
  return 'error.main';
};

const RecentActivity = ({ activities, loading }) => {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Recent Activity</Typography>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="textSecondary">Loading...</Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const defaultActivities = [
    { id: 1, type: 'work_order', title: 'GPS Installation', description: 'Vehicle ABC-123', status: 'completed', date: new Date(), client: 'Transport Co' },
    { id: 2, type: 'work_order', title: 'Maintenance Check', description: 'Vehicle XYZ-789', status: 'in-progress', date: new Date(), client: 'Logistics Inc' },
    { id: 3, type: 'work_order', title: 'Device Replacement', description: 'Vehicle DEF-456', status: 'pending', date: new Date(), client: 'Delivery Services' },
  ];

  const displayActivities = activities?.length > 0 ? activities : defaultActivities;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>Recent Activity</Typography>
        <List>
          {displayActivities.slice(0, 5).map((activity, index) => (
            <ListItem key={activity.id || index} divider={index < 4}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: getActivityColor(activity.type, activity.status) }}>
                  {getActivityIcon(activity.type, activity.status)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2" fontWeight={500}>
                      {activity.title}
                    </Typography>
                    <Chip
                      label={activity.status?.replace('-', ' ').toUpperCase()}
                      size="small"
                      sx={{
                        bgcolor: getActivityColor(activity.type, activity.status),
                        color: 'white',
                        height: 20,
                        '& .MuiChip-label': { fontSize: 10, px: 1 }
                      }}
                    />
                  </Box>
                }
                secondary={
                  <>
                    <Typography variant="caption" color="textSecondary" display="block">
                      {activity.description}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formatDistanceToNow(new Date(activity.date), { addSuffix: true })}
                      {activity.client && ` • ${activity.client}`}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default RecentActivity;